<template>
    <div class="main_div">
        <div class="headerTop mb-1">
            <div class="">
                <h3 class="header_title">Plan de cuentas</h3>
                <div class="header_description">
                    Las cuentas permiten agrupar la data financiera de tu
                    negocio.
                </div>
                <div class="is-pulled-right">
                    <span class="theme_btn_white is-clickable ml-3"
                        @click="() => downloadAllPlanAccounts()">Exportar</span>
                </div>
            </div>
            <div class="navbar-divider"></div>
        </div>
        <div class="underHeader">
            <div v-for="(planAccount, iPlanAccount) of planAccounts" v-bind:key="planAccount.id" class="mb-5 ml-1">
                <div class="is-plan-account" @click.prevent="() => changeOpenView(iPlanAccount, null)">
                    <ArrowDown :class="[
                        'actual_button_arrow_down',
                        'color-arrow-green',
                        { rotate_arrow: planAccount.isOpen },
                    ]" />
                    <span class="textTitle">
                        {{ iPlanAccount + 1 }}. {{ planAccount.name }}
                    </span>
                </div>
                <div v-if="planAccount.isOpen">
                    <div v-for="(
subCuenta, iSubCuenta
                        ) in planAccount.subAccounts" v-bind:key="subCuenta.id">
                        <div class="is-sub-plan-account" v-if="subCuenta.name != 'Ventas'" @click.prevent="
                            () => changeOpenView(iPlanAccount, iSubCuenta)
                        ">
                            <ArrowDown :class="[
                                'actual_button_arrow_down',
                                'color-arrow-purple',
                                { rotate_arrow: subCuenta.isOpen },
                            ]" />
                            <span class="text-sub-title">
                                {{ iPlanAccount + 1 }}.{{ iSubCuenta + 1 }}
                                {{ subCuenta.name }}
                            </span>
                        </div>
                        <div v-if="subCuenta.isOpen">
                            <div class="is-item-account" v-for="(item, iItem) in subCuenta.items" v-bind:key="item.id">
                                <span class="text-item">
                                    {{ iPlanAccount + 1 }}.{{
                                        iSubCuenta + 1
                                    }}.{{ iItem + 1 }} {{ item.name }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { get_account_plan_by_company_ordered } from "@/api/carteraAnalista";
import ArrowDown from "@/components/svg/ArrowDown.vue";
export default {
    name: "AccountsPlan",
    components: {
        ArrowDown,
    },
    data() {
        return {
            planAccounts: [],
        };
    },
    methods: {
        changeOpenView(posPlanAccount, posSubPlanAccount) {
            if (posSubPlanAccount != null) {
                const actualOpen =
                    this.planAccounts[posPlanAccount].subAccounts[
                        posSubPlanAccount
                    ].isOpen;
                this.planAccounts[posPlanAccount].subAccounts[
                    posSubPlanAccount
                ].isOpen = !actualOpen;
            } else {
                const actualOpen = this.planAccounts[posPlanAccount].isOpen;
                this.planAccounts[posPlanAccount].isOpen = !actualOpen;
            }
        },
        async downloadAllPlanAccounts() {
            // Carga la librería dinámicamente solo cuando se necesita
            const XLSX = await import('xlsx');
            let data = []

            this.planAccounts.map((plan) => {
                plan.subAccounts.map((subAccount) => {
                    subAccount.items.map((item) => {
                        data.push({
                            "Nivel 1": plan.name,
                            "Nivel 2": subAccount.name,
                            "Nivel 3": item.name,
                        });
                    });
                });
            });

            // Crear hoja y libro de trabajo
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Plan de cuentas");

            // Generar y descargar el archivo
            XLSX.writeFile(workbook, "Plan de cuentas.xlsx");
        },
    },
    props: {},
    mounted() {
        get_account_plan_by_company_ordered({}).then(({ data }) => {
            const accountPlans = data.account_plans;
            let planAccounts = [];
            let dictPlanAccounts = [];
            accountPlans.map((accountPlan, iAccount) => {
                const plan = {
                    name: accountPlan.level_1,
                    id: iAccount,
                    isOpen: true,
                    subAccounts: [],
                };
                if (!dictPlanAccounts[plan.name]) {
                    dictPlanAccounts[plan.name] = {
                        name: accountPlan.level_1,
                        id: iAccount,
                        subAccounts: [],
                    };
                    planAccounts.push({ ...plan });
                }

                const posPlanAccount = planAccounts.findIndex(
                    (planO) => planO.name == plan.name,
                );
                const selected = planAccounts[posPlanAccount];
                const subPlan = {
                    name: accountPlan.level_2,
                    id: iAccount,
                    isOpen: true,
                    items: [],
                };
                if (!dictPlanAccounts[plan.name].subAccounts[subPlan.name]) {
                    dictPlanAccounts[plan.name].subAccounts[subPlan.name] = {
                        name: accountPlan.level_2,
                        id: iAccount,
                        items: [],
                    };
                    selected.subAccounts.push({ ...subPlan });
                }

                const posSubPlanAccount = selected.subAccounts.findIndex(
                    (subPlanO) => subPlanO.name == subPlan.name,
                );
                const subPlanSelected = selected.subAccounts[posSubPlanAccount];
                const item = {
                    name: accountPlan.level_3,
                    id: iAccount,
                };
                subPlanSelected.items.push(item);
            });
            this.planAccounts = planAccounts;
        });
    },
};
</script>

<style lang="scss" scoped>
* {
    font-family: Inter;
}

.headerTop {
    position: sticky;
    top: 114px;
    width: 100%;
    background-color: white;
    border-top: 1px solid #eaecf0;
    z-index: 5;
}

.underHeader {
    position: relative;
}

.header_title {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: 5px;
    padding-top: 30px;
}

.header_description {
    font-size: 1em;
    color: gray;
}

.grey {
    background-color: gray;
}

.main_div {
    padding-left: clamp(10px, 5.5vw, 90px);
    padding-right: clamp(10px, 5.5vw, 93px);
    padding-bottom: 30px;
    background-color: #fcfcfd;
}

.is-plan-account {
    padding: 14px;
    align-items: center;
    align-self: stretch;
    border: 1px solid #eee;
    background: #f2f4f7;

    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    cursor: pointer;
    user-select: none;

    .textTitle {
        color: #1e1e1e;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
    }
}

.is-sub-plan-account {
    padding: 14px 14px 14px 32px;
    align-items: center;
    align-self: stretch;
    border: 1px solid #eee;
    background: #f9fafb;
    cursor: pointer;
    user-select: none;

    .text-sub-title {
        color: #1e1e1e;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
    }
}

.is-item-account {
    padding: 18px 14px 18px 76px;
    align-items: center;
    align-self: stretch;
    border: 1px solid #eee;
    background: #fff;
    user-select: none;

    .text-item {
        color: #1e1e1e;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
    }
}

.is-item-account:last-child {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
}

.actual_button_arrow_down {
    flex-shrink: 0;
    -ms-flex-align: end;
    align-self: center;
    width: 20px;
    height: 20px;
    padding-top: 4px;
}

.color-arrow-green {
    filter: brightness(0) saturate(100%) invert(44%) sepia(88%) saturate(2766%) hue-rotate(152deg) brightness(98%) contrast(100%);
}

.color-arrow-purple {
    filter: brightness(0) saturate(100%) invert(25%) sepia(29%) saturate(6140%) hue-rotate(244deg) brightness(89%) contrast(106%);
}

.rotate_arrow {
    transform: rotate(180deg);
    margin-bottom: -5px;
}

@mixin theme-button($background-color, $border-color, $color-text) {
    border-radius: 8px;
    background-color: $background-color;
    color: $color-text;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    border: 1px solid $border-color;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    padding: 10px 14px;
    justify-content: center;
    align-items: center;
}

.theme_btn_white {
    @include theme-button(white, #ebebeb, black);
}
</style>
